const translations = {
  "Apply": {
    en: "Apply",
    es: "Aplicar",
    pt: "Aplicar"
  },
  "Enter the code of your pass": {
    en: "Enter the code of your pass",
    es: "Ingresa el código de tu pase",
    pt: "Insira o código do seu passe"
  },
  "Paste your code here": {
    en: "Paste your code here",
    es: "Pega tu código aquí",
    pt: "Cola seu código aqui"
  },
  "This section is not available in your country": {
    es: "Esta sección no está disponible en tu país",
    en: "This section is not available in your country",
    pt: "Esta seção não está disponível no seu país",
  },
  "Passes redemption is only available in": {
    es: "El canje de pasos solo está disponible en",
    en: "Passes redemption is only available in",
    pt: "Canje de passos disponível apenas em",
  },
  "Select the means by which you acquired the pass": {
    en: "Select the means by which you acquired the pass",
    es: "Selecciona el medio por el que adquiriste el pase",
    pt: "Selecione o meio pelo qual você adquiriu o passe"
  },
  'By clicking on': {
    en: 'By clicking on',
    es: 'Al hacer clic en',
    pt: 'Ao clicar em'
  },
  'you agree to the': {
    en: 'you agree to the',
    es: 'aceptas los',
    pt: 'você concorda com os'
  },
  "Searching for your pass": {
    en: "Searching for your pass",
    es: "Buscando tu pase",
    pt: "Procurando seu passe"
  },
  "If you activate your pass now you'll have access until": {
    en: "If you activate your pass now you'll have access until",
    es: "Si activas tu pase ahora tendrás acceso hasta el",
    pt: "Se você ativar seu passe agora terá acesso até"
  },
  'Activate': {
    en: 'Activate',
    es: 'Activar',
    pt: 'Ativar'
  },
  'Activate pass': {
    en: 'Activate pass',
    es: 'Activar pase',
    pt: 'Ativar passe'
  },
  'Activate now': {
    en: 'Activate now',
    es: 'Activar ahora',
    pt: 'Ativar agora'
  },
  'Activate later': {
    en: 'Activate later',
    es: 'Activar más tarde',
    pt: 'Ativar mais tarde'
  },
  "You've got until": {
    en: "You've got until",
    es: "Tendrás hasta",
    pt: "Você tem até"
  },
  "to activate your pass or giftcard. To do so just got to the menu in the main page and select the Activate your pass option": {
    en: "to activate your pass or giftcard. To do so just got to the menu in the main page and select the Activate your pass option",
    es: "para activar tu pase o giftcard. Para hacerlo solo ve al menú en la página principal y selecciona la opción Activar tu pase",
    pt: "para ativar seu passe ou giftcard. Para fazer isso, apenas vá ao menu na página principal e selecione a opção Ativar seu passe"
  },
  "This code has already been used": {
    en: "This code has already been used",
    es: "Este código ya ha sido utilizado",
    pt: "Este código já foi utilizado"
  },
  "This code has expired": {
    en: "This code has expired",
    es: "Este código ha expirado",
    pt: "Este código expirou"
  },
  "Your pass has been activated successfully": {
    en: "Your pass has been activated successfully",
    es: "Tu pase ha sido activado con éxito",
    pt: "Seu passe foi ativado com sucesso"
  },
  "You already have an active order for this product": {
    en: "You already have an active order for this product",
    es: "Ya tienes una orden activa para este producto",
    pt: "Você já tem uma ordem ativa para este produto"
  },
  "Please cancel your current order and try again": {
    en: "Please cancel your current order and try again",
    es: "Por favor, cancela tu orden actual y vuelve a intentarlo",
    pt: "Por favor, cancele sua ordem atual e tente novamente"
  },
  "Please verify your code and try again": {
    en: "Please verify your code and try again",
    es: "Por favor, verifica tu código y vuelve a intentarlo",
    pt: "Por favor, verifique seu código e tente novamente"
  },
  "It seems like this code has already been used. Remember that each code can only be used once.": {
    en: "It seems like this code has already been used. Remember that each code can only be used once.",
    es: "Parece que este código ya ha sido utilizado. Recuerda que cada código solo puede ser utilizado una vez.",
    pt: "Parece que este código já foi utilizado. Lembre-se de que cada código pode ser usado apenas uma vez."
  },
  "Invalid code": {
    en: "Invalid code",
    es: "Código inválido",
    pt: "Código inválido"
  },
  "Product not available": {
    en: "Product not available",
    es: "Producto no disponible",
    pt: "Produto não disponível"
  },
  "There was an error activating your pass. Please try again later.": {
    en: "There was an error activating your pass. Please try again later.",
    es: "Ocurrió un error al activar tu pase. Por favor, inténtalo de nuevo más tarde.",
    pt: "Ocorreu um erro ao ativar seu passe. Por favor, tente novamente mais tarde."
  }
};

export default translations;
